import { useMemo, useState, type ReactNode } from "react";
import { I18nContext, createTranslator, getStoredLanguage, storeLanguage, type Language } from "@/i18n";

export function I18nProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => getStoredLanguage());

  const setLanguage = (next: Language) => {
    storeLanguage(next);
    setLanguageState(next);
  };

  const value = useMemo(() => ({ language, setLanguage, t: createTranslator(language) }), [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
